import React from "react";

function Mail(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="320"
      height="320"
      version="1"
      viewBox="0 0 240 240"
      className={props.class}
    >
      <path
        id={props.id}
        d="M0 1200V300h2400v1800H0v-900zm1883 482c-147-119-361-293-476-385l-207-168-208 168c-114 92-328 266-475 385l-269 218h1904l-269-218zM453 1477c143-116 205-172 199-180-14-20-435-541-444-552-4-5-8 204-8 464v472l23-18c12-10 116-94 230-186zm1745-490l-3-234-185 224c-102 124-204 249-228 278l-43 54 228 184 228 185 3-228c1-126 1-334 0-463zm-1194 43c101-83 190-150 196-150s95 68 197 151 189 147 193 142c4-4 130-156 279-338l271-330-471-3c-259-1-679-1-935 0l-463 3 272 337c149 186 273 338 274 338 2 0 86-67 187-150z"
        transform="matrix(.1 0 0 -.1 0 240)"
      ></path>
    </svg>
  );
}

export default Mail;
